export const SET_THANK_YOU_PAGE_API_DATA = 'SET_THANK_YOU_PAGE_API_DATA';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_PAYMENT_ID_AND_PAYMENT_SESSION_ID = 'SET_PAYMENT_ID_AND_PAYMENT_SESSION_ID';
// export const SET_FLAVOUR = 'SET_FLAVOUR';
export const INCREASE_API_HIT_COUNT = 'INCREASE_API_HIT_COUNT';
export const HIT_API = 'HIT_API';
export const SET_TQ_OMNITURE_INFO = 'SET_TQ_OMNITURE_INFO';
export const SET_MISSED_TQ_OMNITURE_EVENTS = 'SET_MISSED_TQ_OMNITURE_EVENTS';
export const RESET_MISSED_TQ_OMNITURE_EVENTS = 'RESET_MISSED_TQ_OMNITURE_EVENTS';

export const setThankYouPageData = actionData => {
  return {
    type: SET_THANK_YOU_PAGE_API_DATA,
    props: {
      data: actionData
    }
  };
};

export const setIsLoading = actionData => {
  return {
    type: SET_IS_LOADING,
    props: {
      isLoading: actionData
    }
  };
};

export const setPaymentIdAndPaymentSessionId = actionData => {
  return {
    type: SET_PAYMENT_ID_AND_PAYMENT_SESSION_ID,
    props: actionData
  };
};

// export const setFlavour = actionData => {
//   return {
//     type: SET_FLAVOUR,
//     props: {
//       flavour: actionData
//     }
//   };
// };

export const increaseApiHitCount = () => {
  return {
    type: INCREASE_API_HIT_COUNT
  };
};

export const hitApi = actionData => {
  return {
    type: HIT_API,
    props: {
      hitApi: actionData
    }
  };
};

export const setTqOmnitureInfo = omnitureInfo => {
  return {
    type: SET_TQ_OMNITURE_INFO,
    props: {
      tqOmnitureInfo: omnitureInfo
    }
  };
};

export const setMissedTQOmnitureEvents = actionData => {
  return {
    type: SET_MISSED_TQ_OMNITURE_EVENTS,
    actionData
  };
};

export const resetMissedTQOmnitureEvents = actionData => {
  return {
    type: RESET_MISSED_TQ_OMNITURE_EVENTS,
    actionData
  };
};
